import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RestClient } from "../../Api/DcoApi/Client/RestClient";
import { Patient } from "../../Api/DcoApi/Patient";
import { Notitz } from "../../Api/DcoApi/Notitz";
import { Observable } from "rxjs/internal/Observable";

@Component({
  selector: 'Notitzen',
  templateUrl: './Notitzen.html',
  styleUrl: './Notitzen.css',
  imports: [FormsModule],
  standalone: true,
})
export class Notitzen implements OnChanges {

  constructor(private cdr: ChangeDetectorRef) { }

  Client: RestClient = new RestClient();
  @Input() patient: Patient | null | undefined = null;
  @Input() Items: Notitz[] = [];
  @Output() ItemsChange = new EventEmitter<Notitz[]>();

  NewText: string = "";

  async SendNewEntry() {

    if (this.patient != null) {

      this.Items = await this.Client.Post<Notitz[], Notitz>(`/Backend/Api/V2/Akte/${this.patient.versicherungsnummer}/Notebook`, { text: this.NewText } as Notitz)
      this.ItemsChange.emit(this.Items);
      this.NewText = "";
      this.cdr.detectChanges();
    }
  }


  async DeleteEntry(id: number) {
    if (this.patient != null) {

      await this.Client.Delete(`/Backend/Api/V2/Akte/${this.patient.versicherungsnummer}/Notebook/${id}`)
      this.Items = await this.Client.Get<Notitz[]>(`/Backend/Api/V2/Akte/${this.patient.versicherungsnummer}/Notebook`)
      this.ItemsChange.emit(this.Items);
      this.cdr.detectChanges();
    }
  }

  
  async ngOnChanges(changes: SimpleChanges) {

    if (changes['patient'] && this.patient != null) {

      this.Items = await this.Client.Get<Notitz[]>(`/Backend/Api/V2/Akte/${this.patient.versicherungsnummer}/Notebook`)
      this.ItemsChange.emit(this.Items);
      this.cdr.detectChanges();
    }
  }

}


